<template>
  <div class="qualifiedInvestor">
    <p>
      <a class="finKnowledge_a" target="_blank" :href="link">Декларация</a>
      <span> Страхователя на соответствие знаниям в области финансов:</span>
    </p>
    <div class="qualifiedInvestor__item" v-for="(question, index) in questions" :key="index">
      <h3 v-html="formatQuestionText(question.text)"></h3>
      <div v-for="option in options" :key="option.value">
        <input
          type="radio"
          :name="'question' + index"
          :value="option.value"
          v-model="answers[question.id]"
          @change="emitAnswers"
        />
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualifiedInvestor",
  props: ["link"],
  emits: ['update-answers'],
  data() {
    return {
      questions: [
        {
          id: 'checkbox_1',
          text: 'Я имею высшее образование (среднее специальное) в области экономики или финансов, окончил(а) курсы повышения квалификации в сфере экономики или финансов, и/или получил(а) сертификат(ы):\n' +
            'квалификационный аттестат специалиста финансового рынка;\n   ' +
            'квалификационный аттестат аудитора;\n   ' +
            'квалификационный аттестат страхового актуария;\n   ' +
            'сертификат «CharteredFinancialAnalyst (CFA)»;\n   ' +
            'сертификат «CertifiedInternationalInvestmentAnalyst (CIIA)»\n' +
            'сертификат «FinancialRiskManager (FRM)».\n'
        },
        {
          id: 'checkbox_2',
          text: 'Я имею опыт работы с финансовыми инструментами:\n' +
            'не менее 2х лет в организации являющейся квалифицированным инвестором; \n' +
            'не менее Зх лет в организации, которая осуществляла сделки с ценными бумагами и/или иными финансовыми инструментами (в том числе страховые компании, НПФ, Банки, УК); \n' +
            'Я имею опыт работы в страховой организации не менее трех лет;\n' +
            'Я имею опыт работы  в сфере реализации (в том числе в организациях – агентах страховых организаций), методологии ИСЖ, НСЖ не менее одного года.\n'
        },
        {
          id: 'checkbox_3',
          text: 'Я владел ранее и / или владею в настоящий момент ценными бумагами или иными финансовыми инструментами и регулярно совершаю сделки с ценными бумагами или заключаю договоры, являющиеся производными финансовыми инструментами (например, за последние четыре квартала в среднем не реже 10 раз в квартал и не реже одного раза в месяц), или повторно заключаю договор страхования с инвестиционной составляющей(под повторным понимается наличие уже завершившего свое действие договора страхования с инвестиционной составляющей).'
        },
        {
          id: 'checkbox_4',
          text: 'Совокупный объем моих активов в финансовых инструментах (включая депозиты, текущие счета, ценные бумаги, доверительное управление, ПИФ, ИИС, денежные средства, в том числе в иностранной валюте и т.п.) превышают в сумме 6.000.000 (шесть миллионов ) рублей.'
        }
      ],
      options: [
        {value: true, label: 'Подтверждаю'},
        {value: false, label: 'Не подтверждаю'}
      ],
      answers: {
        checkbox_1: null,
        checkbox_2: null,
        checkbox_3: null,
        checkbox_4: null
      }

    }
  },
  methods: {
    emitAnswers() {
      this.$emit('update-answers', {...this.answers})
    },
    formatQuestionText(text) {
      // Заменяем переносы строк на <br> (если они есть)
      return text.replace(/\n/g, '<br>')
    }
  }
}
</script>

<style scoped>

</style>